import m from "./../../../dist/es2015/locales/zh_Hans.js";
export const am5locales_zh_Hans = m;